import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-sgkd002d-button',
  templateUrl: './sgkd002d-button.component.html',
  styleUrl: './sgkd002d-button.component.scss'
})
export class Sgkd002dButtonComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  @Input() mainForm: UntypedFormGroup;

  constructor(private router: Router) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd002dButtonComponent
   */
  ngOnInit(): void {
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd002dButtonComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 前画面に戻る
   *
   * @memberof Sgkd002dButtonComponent
   */
  public goToPrevious(): void {
    window.close();
  }
}
